import axiosPrivate from "./axiosPrivate";

export const getPapeletas = () => {
  return axiosPrivate.post("getPapeletas");
};

export const getPapeletaDetalle = (papeleta_id) => {
  return axiosPrivate.post("getPapeletaDetalle", { papeleta_id });
};

export const insertPapeleta = (data) => {
  return axiosPrivate.post("papeleta-salida", data);
};

export const aprobarJefe = (data) => {
  return axiosPrivate.post("papeleta-salida/aprobar-jefe", data);
};

export const rechazarJefe = (data) => {
  return axiosPrivate.post("papeleta-salida/rechazar-jefe", data);
};

export const aprobarTH = (data) => {
  return axiosPrivate.post("papeleta-salida/aprobar-th", data);
};

export const rechazarTH = (data) => {
  return axiosPrivate.post("papeleta-salida/rechazar-th", data);
};

export const guardarArchivoPapeleta = (formData) => {
  return axiosPrivate.post("papeleta-salida/guardar-archivo", formData, {
    headers: { "Content-Type": "multipart/form-data" }
  });
};

export const updateTipoSalida = (data) => {
  return axiosPrivate.post("papeleta-salida/update-tipo-salida", data);
};
